"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSmartSolutions = function IconSmartSolutions(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m16.363 4.649 7.574 7.574-1.414 1.414-6.187-6.186-5.272 5.08-1.388-1.441zm3.537 36.67a.72.72 0 1 0 0-1.44.72.72 0 0 0 0 1.44M24 15h-9a5 5 0 0 0-5 5v19a5 5 0 0 0 5 5h9a5 5 0 0 0 5-5V20a5 5 0 0 0-5-5m-9 2h9a3 3 0 0 1 3 3v18H12V20a3 3 0 0 1 3-3m-3 22h15a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3m9-19v-1h-3v1zm7.448-8.055a5.25 5.25 0 0 1 4.468 4.38l.03.229-.993.112a4.25 4.25 0 0 0-3.437-3.697l-.204-.034zm6.936 4.093a7.73 7.73 0 0 0-6.596-6.533l-.136.99.252.04a6.73 6.73 0 0 1 5.52 5.871l.993-.112zm-6.266-8.983a10.19 10.19 0 0 1 8.693 8.657l.036.281-.994.114a9.19 9.19 0 0 0-7.602-8.02l-.27-.042zM35 37v8.246q-.781.406-1.595.754H33V35h6v-4.585l-8.397-8.398 1.414-1.414L41 29.586V37z",
    clipRule: "evenodd"
  })));
};

export { IconSmartSolutions, IconSmartSolutions as default };
